//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitJoin.js";
import "../no/SelectObjectList.js";
import "../GeometricUtilities/GeometricUtilities.CurveOptions.js";
import "../no/SelectDisplayableObject.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AngleToProjectionVector",0,"Expression",0],[0,"BridgedGapSize",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitJoinData",0,"GeometricUtilities.CurveFitJoin",1],[0,"EqualArcLengthMethod",1,0],[1,"FaceToProjectTo",0,"SelectObjectList",0],[0,"GapOption",1,0],[1,"InputCurvesOption",0,"GeometricUtilities.CurveOptions",0],[1,"LineToProjectToward",0,"SelectDisplayableObject",0],[0,"NearestPointOption",1,0],[0,"PlaneToProjectTo",1,"Plane",0],[0,"PointToProjectToward",1,"Point",0],[0,"ProjectionDirectionMethod",1,0],[0,"ProjectionOption",1,0],[0,"ProjectionVector",1,"Direction",0],[0,"ReferencePointForEqualArcLength",1,"Point",0],[1,"SectionToProject",0,"Section",0],[0,"Tolerance",1,0],[0,"XVectorForEqualArcLength",1,"Direction",0]],[],[]];
SPLM.Features.ProjectCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ProjectCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ProjectCurveBuilder.DirectionType = Object.freeze({
    "AlongFaceNormal" : "AlongFaceNormal", "TowardPoint" : "TowardPoint", "TowardLine" : "TowardLine", "AlongVector" : "AlongVector", "AngleToVector" : "AngleToVector"});

SPLM.Features.ProjectCurveBuilder.ProjectionOptionType = Object.freeze({
    "None" : "None", "ProjectBothSides" : "ProjectBothSides", "EqualArcLength" : "EqualArcLength"});

SPLM.Features.ProjectCurveBuilder.ArcLengthType = Object.freeze({
    "BothXY" : "BothXY", "FirstXThenY" : "FirstXThenY", "FirstYThenX" : "FirstYThenX", "XOnly" : "XOnly", "YOnly" : "YOnly"});

export default SPLM;